<dashboard-dialog-frame class="volunteer-dialog" [header]="headerName()" [actions]="actions" [dialogRef]="dialogRef">

	@if(volunteerDetails(); as volunteer){
	<kendo-tabstrip class="h-100 px-2 pt-2">

		<kendo-tabstrip-tab title="Overview" [selected]="true">
			<ng-template kendoTabContent>
				<volunteer-application-overview-content-dialog-part></volunteer-application-overview-content-dialog-part>
			</ng-template>
		</kendo-tabstrip-tab>

		<kendo-tabstrip-tab title="Status">
			<ng-template kendoTabContent>
				<volunteer-application-status-log-dialog-part></volunteer-application-status-log-dialog-part>
			</ng-template>
		</kendo-tabstrip-tab>

		<kendo-tabstrip-tab title="Interview">
			<ng-template kendoTabContent>
				<lead-volunteer-interview-dialog-part></lead-volunteer-interview-dialog-part>
			</ng-template>
		</kendo-tabstrip-tab>

		<kendo-tabstrip-tab title="Topics">
			<ng-template kendoTabContent>
				<volunteer-dialog-topics-part [dialogBodyHeight]="dialogContext.dimensions().bodyHeight"></volunteer-dialog-topics-part>
			</ng-template>
		</kendo-tabstrip-tab>

		<kendo-tabstrip-tab title="Mentor Sign-ups">
			<ng-template kendoTabContent>
				<volunteer-mentor-signups-dialog-part [dialogBodyHeight]="dialogContext.dimensions().bodyHeight"></volunteer-mentor-signups-dialog-part>
			</ng-template>
		</kendo-tabstrip-tab>

		<kendo-tabstrip-tab title="Mentor Schedule">
			<ng-template kendoTabContent>
				<volunteer-schedule-part></volunteer-schedule-part>
			</ng-template>
		</kendo-tabstrip-tab>

		<kendo-tabstrip-tab title="Specialist Sign-ups">
			<ng-template kendoTabContent>
				<volunteer-specialist-signups-dialog-part [dialogBodyHeight]="dialogContext.dimensions().bodyHeight"></volunteer-specialist-signups-dialog-part>
			</ng-template>
		</kendo-tabstrip-tab>

		@if(canSeeManagementTab()){
		<kendo-tabstrip-tab title="Management">
			<ng-template kendoTabContent>
				<volunteer-management-dialog-part></volunteer-management-dialog-part>
			</ng-template>
		</kendo-tabstrip-tab>
		}

	</kendo-tabstrip>
	}

</dashboard-dialog-frame>